import React, { forwardRef, RefObject, useEffect, useRef } from 'react';
import { scaleLinear as d3scaleLinear } from 'd3';

import { AnyScale, JSONArray } from '../../types';
import { ScatterPlotProps } from './types';
import { StyledScatterPlot, StyledScatterPlotEmptyText } from './styles';
import { Axis } from '../Axis';
import { sizeToDimension } from './utils';
import { useTheme } from '@redsift/design-system';

export const EmptyScatterPlot = forwardRef<HTMLDivElement, ScatterPlotProps>((props, ref) => {
  const { className, data: propsData, emptyComponent, localeText, size, ...forwardedProps } = props;
  const theme = useTheme();

  const cache = useRef<JSONArray>();

  const data = propsData;

  useEffect(() => {
    cache.current = data;
  });

  const chartDimensions = sizeToDimension(size!);
  const width = chartDimensions.width;
  const height = chartDimensions.height;
  const margins = { top: 16, left: 48, right: 16, bottom: 48 };
  const chartWidth = width - margins.left - margins.right;

  return (
    <StyledScatterPlot {...forwardedProps} className={className} ref={ref as RefObject<HTMLDivElement>}>
      {emptyComponent ?? (
        <>
          <StyledScatterPlotEmptyText $maxWidth={width} $textSize={chartDimensions.fontSize / 2} $theme={theme}>
            <span>{localeText?.emptyChartText}</span>
          </StyledScatterPlotEmptyText>
          <svg width={width} height={height}>
            <g transform={`translate(${margins.left},${margins.top})`}>
              <Axis
                position="bottom"
                length={width - 32}
                scale={d3scaleLinear().domain([]).range([0, chartWidth]) as AnyScale}
                x={0}
                y={height}
                tickValues={4}
              />
            </g>
          </svg>
        </>
      )}
    </StyledScatterPlot>
  );
});
